/* eslint-disable function-paren-newline */
// import anonymizeIP from '../../utils/anonymizeIp';

export default () => {
  window.dataLayer = window.dataLayer || [];
  const template = document.querySelector('[data-template]');
  const customer = document.querySelector('[data-customer-id]');
  const customerId = customer.getAttribute('data-customer-id');
  const isProductPage = window.ShopifyAnalytics.meta.page.pageType === 'product';
  const isCollectionPage = window.ShopifyAnalytics.meta.page.pageType === 'collection';
  const isSearchPage = document.querySelector('[data-template="page.product_search"]') !== null;
  const isPressPage = document.querySelector('[data-template="page.press"]') !== null;
  const isAmbassadorPage = document.querySelector('[data-template="page.ambassador"]') !== null;
  const isCareersPage = document.querySelector('[data-template="page.careers"]') !== null;
  const isStoreLocationsPage = document.querySelector('[data-template="page.locations"]') !== null;
  const isAffiliatePage = document.querySelector('[data-template="page.affiliate"]') !== null;

  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      window.clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  }
  function formInteraction(eventName) {
    window.dataLayer.push({
      event: eventName,
    });
  }

  /* eslint-disable-next-line no-unused-vars */
  function getSelectedVariant(id, productObject) {
    const itemId = Number(id);
    const variantPrice = productObject.variants.find((item) => {
      return item.id === itemId;
    });
    return variantPrice;
  }

  /* Global */
  const logos = document.querySelectorAll('[data-logo]');
  logos.forEach((logo) => {
    logo.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'windsor_logo_click',
      });
    });
  });

  /* Global */
  const announcementBar = document.querySelectorAll('[data-announcement]');
  announcementBar.forEach((element) => {
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'announcement_bar_click',
        banner_name: element.innerText,
        banner_location: window.ShopifyAnalytics.meta.page.pageType,
      });
      window.dataLayer.push({
        event: 'top_bar_click',
        banner_name: element.innerText,
        banner_location: window.ShopifyAnalytics.meta.page.pageType,
      });
    });
  });

  /* Global */
  const topNavBtns = document.querySelectorAll('.PreHeader .gtm-track--click');

  if (topNavBtns.length > 0) {
    topNavBtns.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        window.dataLayer.push({
          event: 'top_nav_click',
          link_text: element.dataset.linkTitle,
          page_type: template.dataset.template,
        });
        if (element.attributes.href) {
          window.location.href = element.attributes.href.value;
        }
      });
    });
  }

  /* Global */
  const podsLinksSubMenu = '.HeaderNav__link--img-link a';
  document.addEventListener('click', (e) => {
    if (!e.target.matches(podsLinksSubMenu)) {
      return;
    }
    const podsLinksSubMenuTtle = e.target.getAttribute('title');
    e.preventDefault();
    window.dataLayer.push({
      event: 'nav_pod_click',
      pod_category: podsLinksSubMenuTtle,
    });
    window.location.href = e.target.attributes.href.value;
  });

  /* Global */
  const topNavLinks = '.HeaderNav__link';
  const mobileMenuLinks = '.MobileMenu__link--sub';
  document.addEventListener('click', (e) => {
    if (e.target.matches(topNavLinks) || e.target.matches(mobileMenuLinks)) {
      e.preventDefault();
      const topLink = e.target;
      const subCategory = topLink.dataset.subCategory;
      const category = topLink.dataset.category;
      const hierarchy = `${topLink.dataset.category} > ${subCategory}`;
      window.dataLayer.push({
        event: 'drop_down_click',
        drop_down_category: category,
        drop_down_sub_category: subCategory,
        drop_down_hierarchy: hierarchy,
        page_type: window.ShopifyAnalytics.meta.page.pageType,
      });
      window.location.href = e.target.attributes.href.value;
    }
  });

  /* Global */
  const socialIcons = document.querySelectorAll('.CustomFooter__social-link');
  socialIcons.forEach((element) => {
    element.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'social_click',
        social_platform: element.dataset.social,
        social_click_location: window.ShopifyAnalytics.meta.page.pageType,
      });
    });
  });

  /* Global */
  const newsletterSignup = document.querySelector('.subscribe-button');
  const locationPath = document.querySelector('[data-location-id]');
  const newsletterForm = document.querySelector('.Footer__newsletter-signupForm'); // we moved it out to footer section
  const emailSignupLocation = locationPath.dataset.locationId;

  newsletterSignup?.addEventListener('click', () => {
    const isValidForm = newsletterForm.checkValidity();
    if (isValidForm) {
      window.dataLayer.push({
        event: 'email_signup',
        email_signup_location: emailSignupLocation,
      });
    }
  });

  /* Global */
  const orderStatusSubmit = document.querySelector('.ShippingStatusModal__form .Button');
  const orderStatusForm = document.querySelector('.ShippingStatusModal__form');
  orderStatusSubmit.addEventListener('click', () => {
    const isValidForm = orderStatusForm.checkValidity();
    if (isValidForm) {
      window.dataLayer.push({
        event: 'order_check_status_submit',
      });
    }
  });

  /* Global */
  const footerLinks = document.querySelectorAll('.CustomFooter__sub_link-container a');

  if (footerLinks.length > 0) {
    footerLinks.forEach((element) => {
      const isModal = element.hasAttribute('data-open-modal');
      if (!isModal) {
        element.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'bottom_nav_click',
            link_text: element.dataset.title,
            page_type: window.ShopifyAnalytics.meta.page.pageType,
          });
        });
      }
    });
  }

  /* Global */
  const accessibilityBtn = document.querySelector('#ae_launcher button');
  if (accessibilityBtn !== null) {
    accessibilityBtn.addEventListener('click', () => {
      window.dataLayer.push({
        event: 'accessibility_toolkit_click',
      });
    });
  }

  /* Global - PLP Quick Shop */
  const quickShopViewDetails = '.ProductInfo__view-details';
  document.addEventListener('click', (e) => {
    if (!e.target.matches(quickShopViewDetails)) {
      return;
    }
    window.dataLayer.push({
      event: 'quick_shop_view_details',
      product_name: e.target.dataset.title,
      product_id: e.target.dataset.id,
    });
  });

  /* VIP Program */
  const vipProgramSubmit = document.querySelector('#vip-form input[type="submit"]');
  const vipProgramForm = document.querySelector('#vip-form form');

  if (vipProgramForm !== null) {
    vipProgramSubmit.addEventListener('click', () => {
      const isValidProgramForm = vipProgramForm.checkValidity();
      if (isValidProgramForm) {
        window.dataLayer.push({
          event: 'vip_signup',
        });
      }
    });
  }

  /* Press Page */
  if (isPressPage) {
    const newsLinks = document.querySelectorAll(
      '[data-article-tile-custom-thumb], [data-article-tile-custom-article-link] a, [data-article-tile-custom-read-more]',
    );
    if (newsLinks.length > 0) {
      newsLinks.forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          window.dataLayer.push({
            event: 'pressroom_news_click',
            pressroom_article_name: element.dataset.articleTitle,
          });
          window.location.href = element.attributes.href.value;
        });
      });
    }

    const pressCategories = document.querySelectorAll('.PressTagCarousel__tag');
    if (pressCategories.length > 0) {
      pressCategories.forEach((element) => {
        element.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'pressroom_category_click',
            pressroom_press_category: element.innerText,
          });
        });
      });
    }

    const pressLinks = document.querySelectorAll('.PageContent a');
    if (pressLinks.length > 0) {
      pressLinks.forEach((element) => {
        element.addEventListener('click', () => {
          const pressType = element.href.replace(/.*\/(\w+)\/?$/, '$1');
          window.dataLayer.push({
            event: 'pressroom_get_in_touch_click',
            pressroom_get_in_touch_type: pressType,
          });
        });
      });
    }
  }

  /* Blog */
  const blogLink = document.querySelectorAll('.BlogMainHeader__link');

  if (blogLink.length > 0) {
    blogLink.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        window.dataLayer.push({
          event: 'blog_category_click',
          blog_category: element.dataset.category,
        });
        window.location.href = element.attributes.href.value;
      });
    });
  }

  /* Blog - Shop This */
  const shopThisBtn = '.ShoppableImage__Button';
  document.addEventListener('click', (e) => {
    if (!e.target.matches(shopThisBtn)) {
      return;
    }

    window.dataLayer.push({
      event: 'blog_shop_this_click',
      blog_shop_this_product: e.target.dataset.product || e.target.parentNode.parentNode.querySelector('p').innerText,
    });
  });

  /* Blog - Read More */
  const readMoreBtn = document.querySelectorAll('.gtm-track .read-more');

  if (readMoreBtn.length > 0 && !isPressPage) {
    readMoreBtn.forEach((element) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();
        window.dataLayer.push({
          event: 'blog_read_more_click',
          blog_category: element.dataset.category,
          blog_article_name: element.dataset.articleTitle,
        });
        window.location.href = element.attributes.href.value;
      });
    });
  }

  /* Ambassador Page */
  if (isAmbassadorPage) {
    const ambassadorFormCheck = debounce(() => formInteraction('ambassador_form_interaction'));
    const formInput = document.querySelectorAll('.AmbassadorForm input, .AmbassadorForm textarea');
    if (formInput.length > 0) {
      formInput.forEach((input) => {
        input.addEventListener('change', ambassadorFormCheck);
      });
    }
  }

  /* Account */
  const queryString = window.location.search;
  const urlParams = new window.URLSearchParams(queryString);
  const loginSuccess = urlParams.get('login_success');
  const isAccountPage = Boolean(document.getElementById('account'));
  const isSignupSuccess = Boolean(window.localStorage.getItem('signup_success'));

  if (isAccountPage && isSignupSuccess) {
    window.dataLayer.push({
      event: 'sign_up',
      user_id: customerId,
    });
    setTimeout(() => {
      window.localStorage.removeItem('signup_success');
    }, 300);
  }

  if (loginSuccess) {
    window.dataLayer.push({
      event: 'login',
      user_id: customerId,
    });
    window.history.pushState({}, null, window.location.href.split('?')[0]);
  }

  /* PLP */
  if (isCollectionPage || isSearchPage) {
    /* PLP Pods Links on top */
    const podsLinks = document.querySelectorAll('.fast_category_title');
    if (podsLinks.length > 0) {
      podsLinks.forEach((element) => {
        element.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'plp_pod_click',
            plp_pods_name: element.innerText,
          });
        });
      });
    }

    /* PLP Clear Filters */

    const plpClearFilters = '.clear_all_removable_tags';
    const plpClearFilterTag = '.removable_tag';
    document.addEventListener('click', (e) => {
      if (
        e.target.matches(plpClearFilters) ||
        e.target.matches(plpClearFilterTag) ||
        e.target.closest(plpClearFilterTag)
      ) {
        window.dataLayer.push({
          event: 'filter_clear',
        });
      }
    });

    /* PLP Show / Hide Filters */
    const plpBtnFilters = '.show_filter';
    const plpBtnFiltersMobile = '.fs_all_filters';
    document.addEventListener('click', (e) => {
      if (e.target.closest(plpBtnFilters) || e.target.closest(plpBtnFiltersMobile)) {
        window.dataLayer.push({
          event: 'filter_click',
        });
      }
    });

    const plpClearFilter = '.fast_sidebar > .closebtn';
    document.addEventListener('click', (e) => {
      if (e.target.closest(plpClearFilter)) {
        window.dataLayer.push({
          event: 'filter_clear',
        });
      }
    });

    /* PLP Sort Selection */
    const sortSelection = document.querySelector('.fs_sort_by_options');
    sortSelection.addEventListener('click', (e) => {
      window.dataLayer.push({
        event: 'sort_by_option_click',
        sort_by_type: e.target.getAttribute('data-value'),
      });
    });

    /* PLP Sort Selection - Mobile */
    const sortSelectionMobile = document.querySelector('#sortForm');
    sortSelectionMobile.addEventListener('click', (e) => {
      let target = e.target;

      // If the target is a label, find the associated input element
      if (target.tagName == 'LABEL') {
        const inputId = target.getAttribute('for');
        target = document.getElementById(inputId);
      }

      // Only push to dataLayer if the target is an input element
      if (target && target.tagName === 'INPUT' && target.type === 'radio') {
        window.dataLayer.push({
          event: 'sort_by_option_click',
          sort_by_type: target.getAttribute('data-value'),
        });
      }
    });

    /* PLP Swatches */
    const plpColorSwatches = '.ProductTile__color-swatch-item';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(plpColorSwatches)) {
        return;
      }
      const plpColor = e.target.getAttribute('title');
      window.dataLayer.push({
        event: 'plp_color_change',
        color_change: plpColor,
      });
    });

    /* PLP Quick Shop */
    const plpQuickShop = '.ProductTile__gtm-click';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(plpQuickShop)) {
        return;
      }
      window.dataLayer.push({
        event: 'quick_shop_click',
        product_name: e.target.dataset.title,
        product_id: e.target.dataset.pid,
      });
    });

    /* PLP Quick Shop - Color Change */
    const plpQuickColorSwatch = '.ProductOption__variant-custom--color';
    let clicks = 0;

    document.addEventListener('click', (e) => {
      const quickShopModal = document.querySelector('.ProductGrid');
      if (quickShopModal === null) {
        // Reset clicks if modal is closed
        clicks = 0;
      }

      if (!e.target.matches(plpQuickColorSwatch)) {
        return;
      }

      clicks += 1;
      if (clicks < 2) {
        // Ignore first click since auto selects first color automatically.
        return;
      }

      window.dataLayer.push({
        event: 'quick_shop_color_change',
        color_change: e.target.dataset.value,
      });
    });

    /* PLP Quick Shop - Size Change */
    const plpQuickSizeSwatch = '.ProductOption__variant--sizes';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(plpQuickSizeSwatch)) {
        return;
      }
      window.dataLayer.push({
        event: 'quick_shop_size_change',
        size_change: e.target.dataset.value,
      });
    });

    /* PLP Quick Shop - Add to Cart */
    const quickShopAddToBag = '.ProductInfo__button';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(quickShopAddToBag)) {
        return;
      }
      window.dataLayer.push({
        event: 'quick_shop_add_to_bag',
        product_name: e.target.dataset.productName,
        product_id: e.target.dataset.productId,
      });
    });

    /* PLP Promotional Banners */
    const promotionalBanner = '.promotional-banner .PromoTile__buttons a';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(promotionalBanner)) {
        return;
      }
      window.dataLayer.push({
        event: 'plp_banner_click',
        plp_banner_name: e.target.dataset.title || window.theme.collection,
        banner_location: window.theme.collection,
      });
    });

    /* PLP Embeded Links */
    const plpEmbededLinks = document.querySelectorAll('.CollectionSEOContent a');
    if (plpEmbededLinks.length > 0) {
      plpEmbededLinks.forEach((element) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          window.dataLayer.push({
            event: 'plp_internal_link_click',
            link_text: element.innerText,
          });
          window.location.href = element.attributes.href.value;
        });
      });
    }
  }

  /* Product */
  if (isProductPage) {
    let productItem;

    try {
      productItem = JSON.parse(window.product_data);
    } catch (error) {
      console.error(error);
    }

    /* Social Icons */
    const pdpSocialIcons = document.querySelectorAll('.SocialSharing__icon');
    pdpSocialIcons.forEach((element) => {
      element.addEventListener('click', () => {
        const social_platform = element.classList.value;
        const re = /\s*(?:-|$)\s*/;
        const platform = social_platform.split(re)[1];
        window.dataLayer.push({
          event: 'social_click',
          social_platform: platform,
          social_click_location: window.ShopifyAnalytics.meta.page.pageType,
        });
      });
    });

    /* Color Swatches */
    const colorSwatches = document.querySelectorAll('.ProductOption__variant-custom--color');
    colorSwatches.forEach((element) => {
      element.addEventListener('click', () => {
        const pdpColor = element.getAttribute('data-value');
        let dataLayerTimeout = 0;

        clearTimeout(dataLayerTimeout);
        // Defer dataLayer push
        dataLayerTimeout = setTimeout(() => {
          window.dataLayer.push({
            event: 'pdp_color_change',
            color_change: pdpColor,
          });
        }, 250);
      });
    });

    /* Size Swatches */
    const sizeSwatches = document.querySelectorAll('.ProductOption__variant--sizes');
    sizeSwatches.forEach((element) => {
      element.addEventListener('click', () => {
        const pdpdSize = element.getAttribute('data-value');
        let dataLayerTimeout = 0;

        clearTimeout(dataLayerTimeout);

        // Defer dataLayer push
        dataLayerTimeout = setTimeout(() => {
          window.dataLayer.push({
            event: 'pdp_size_change',
            size_change: pdpdSize,
          });
        }, 250);
      });
    });

    /* Accordion Tabs */
    const pdpAccordionTabs = document.querySelectorAll('.ProductAccordion__section .Accordion__heading');
    if (pdpAccordionTabs.length > 0) {
      pdpAccordionTabs.forEach((element) => {
        element.addEventListener('click', () => {
          const pdpAccordionTab = element.dataset.sectionId;
          window.dataLayer.push({
            event: `pdp_${pdpAccordionTab}_click`,
            product_name: element.dataset.productName,
            product_id: element.dataset.productId,
          });
        });
      });
    }

    /* Out of Stock Products */
    const isProductAvailable = window.is_product_available;
    if (isProductAvailable === 'false') {
      window.dataLayer.push({
        event: 'product_out_of_stock',
        product_name: productItem.title,
        product_id: productItem.id,
      });
    }

    /* Product Waitlist */
    const pdpWaitlistBtn = '[data-add-to-cart="false"]';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(pdpWaitlistBtn)) {
        return;
      }
      window.dataLayer.push({
        event: 'add_to_waitlist_click',
        product_name: e.target.dataset.productName,
        product_id: e.target.dataset.productId,
      });
    });

    /* PDP Quick Shop */
    const plpQuickShop = '.ProductTile__gtm-click';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(plpQuickShop)) {
        return;
      }
      window.dataLayer.push({
        event: 'quick_shop_click',
        product_name: e.target.dataset.title,
        product_id: e.target.dataset.pid,
      });
    });
  }

  /* Carrers Page */
  if (isCareersPage) {
    const careersLink = document.querySelectorAll('.CareersPortal__link, .CareersPortal__button, .CareersHero .Button');
    if (careersLink.length > 0) {
      careersLink.forEach((element) => {
        element.addEventListener('click', () => {
          const careerCategory = element.innerText;
          window.dataLayer.push({
            event: 'career_page_interaction',
            career_open_role_category: careerCategory,
          });
        });
      });
    }
  }

  /* Store Locations */
  if (isStoreLocationsPage) {
    /* Store Locations Lst Results */
    const storeLocationsLink = '.LocationsInRange__details';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(storeLocationsLink)) {
        return;
      }
      const storeName = e.target.dataset.store;
      e.preventDefault();
      window.dataLayer.push({
        event: 'location_search_full_details',
        location_store: storeName,
      });
      window.location.href = e.target.attributes.href.value;
    });

    const storeLocatorRange = document.getElementById('store-locator-range');

    if (storeLocatorRange) {
      storeLocatorRange.addEventListener('change', (event) => {
        window.dataLayer.push({
          event: 'location_search_distance_change',
          location_range: event.target.value,
        });
      });
    }

    /* Store Locations Map Window */
    const locationMapLink = '.details_link';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(locationMapLink)) {
        return;
      }
      const storeName = e.target.dataset.store;
      e.preventDefault();
      window.dataLayer.push({
        event: 'location_map_full_details',
        location_store: storeName,
      });
      window.location.href = e.target.attributes.href.value;
    });

    /* Store Locations Map Window */
    const locationPhoneLink = '.LocationsInRange__phone';
    document.addEventListener('click', (e) => {
      if (!e.target.matches(locationPhoneLink)) {
        return;
      }

      e.preventDefault();
      window.dataLayer.push({
        event: 'location_call_click',
        location_store: e.target.dataset.store,
      });
      window.location.href = e.target.attributes.href.value;
    });
  }

  /* Affiliated */
  if (isAffiliatePage) {
    const affiliateLink = document.querySelectorAll('.AffiliateSignup__cta a, .ContentBlock__button');
    if (affiliateLink.length > 0) {
      affiliateLink.forEach((element) => {
        element.addEventListener('click', () => {
          window.dataLayer.push({
            event: 'affiliate_apply_today_click',
          });
        });
      });
    }
  }
};
